export default function DepartmentController(
  $rootScope,
  $scope,
  $q,
  $filter,
  ssDialogService,
  alerts,
  loaderService,
  emDataService,
  confirmDialog,
  editDepartmentDialog,
  editProcessDialog
) {
  const vm = this;

  vm.isExpanded = false;
  vm.handleExpandDepartment = _handleExpandDepartment;
  vm.handleAddProcess = _handleAddProcess;
  vm.handleEditDepartment = _handleEditDepartment;
  vm.handleDeleteDepartment = _handleDeleteDepartment;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    $scope.$on('refreshDepartment', ($event, refreshDepartmentArgs) => {
      if (vm.department.departmentId === refreshDepartmentArgs.department.departmentId) {
        vm.department = refreshDepartmentArgs.department;
      }
    });
    $scope.$on('expandDepartment', ($event, expandDepartmentArgs) => {
      if (vm.department.departmentId === expandDepartmentArgs.departmentId) {
        vm.isExpanded = true;
      }
    });
    $scope.$on('collapseDepartment', ($event, expandDepartmentArgs) => {
      if (vm.department.departmentId === expandDepartmentArgs.departmentId) {
        vm.isExpanded = false;
      }
    });
    $scope.$emit('departmentDirectiveEventsSet');
  }

  function _handleExpandDepartment() {
    if (vm.department.processes.length > 0) {
      vm.isExpanded = !vm.isExpanded;
    }
  }

  function _handleAddProcess($event) {
    const process = {
      processId: 0,
      canEditProcess: true,
    };
    emDataService.getSuccessorOptions(process.processId).then((response) => {
      ssDialogService.dialogs.enterpriseModeling.editProcessDialog = ssDialogService.alert(
        editProcessDialog.getOptions($event, {
          customerId: vm.customerId,
          department: vm.department,
          process,
          isIt: vm.isIt,
          successorOptions: response
        })
      );
      ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.editProcessDialog);
    });
  }

  function _handleEditDepartment($event) {
    loaderService.showViewLoader = true;
    emDataService.getDepartment(vm.department.departmentId, vm.customerId).then((getDepartmentResponse) => {
      try {
        ssDialogService.dialogs.enterpriseModeling.editDepartmentDialog = ssDialogService.alert(
          editDepartmentDialog.getOptions($event, {
            customerId: vm.customerId,
            department: getDepartmentResponse.data,
            isIt: vm.isIt
          })
        );
        ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.editDepartmentDialog);
      } catch (error) {
        console.error(error);
      }
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _handleDeleteDepartment($event) {
    ssDialogService.dialogs.enterpriseModeling.deleteDepartmentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Department?',
        message: `Are you sure you want to delete department "${vm.department.name}"?`,
        handleYesClick: vm.handleConfirmDelete,
        handleNoClick: vm.handleCancelDelete,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.deleteDepartmentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return emDataService.deleteDepartment(vm.department.departmentId)
      .then(() => {
        alerts.success('The department has been deleted successfully.');
        $rootScope.$broadcast('refreshDepartments');
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('An error occurred while deleting the department.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.enterpriseModeling.deleteDepartmentConfirmDialog);
  }
}

DepartmentController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  'ssDialogService',
  'alerts',
  'loaderService',
  'emDataService',
  'confirmDialog',
  'editDepartmentDialog',
  'editProcessDialog'
];
